import convertTimestampToShamsi from '@/common/utils/convertTimestampToShamsi';
import {
  GetCulpritDriverInfoQueryParamsType,
  GetCulpritDriverInfoQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/getculpritDriverInfo/getCulpritDriverInfoQuery.type';
import { getCulpritDriverInfoFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/getculpritDriverInfo/getCulpritDriverInfoQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const getCulpritDriverInfoQueryOptions = (
  params: GetCulpritDriverInfoQueryParamsType,
) => {
  return queryOptions({
    queryKey: ['culpritDriverInfo', params],
    queryFn: () => getCulpritDriverInfoFunction(params),
    select: (data: GetCulpritDriverInfoQueryResponseType) => {
      return {
        ...data,
        personal_information: {
          ...data.personal_information,
          at_fault_driver: {
            label: data?.personal_information?.at_fault_driver?.fa_const,
            value: data?.personal_information?.at_fault_driver?.const,
          },
          birthdate:
            data?.personal_information?.birthdate &&
            convertTimestampToShamsi(
              Number(data?.personal_information?.birthdate),
            ),
          gender: data?.personal_information?.gender?.const,
          is_owner_driver:
            data?.personal_information?.is_owner_driver === true ? true : false,
          driver_iranian:
            data?.personal_information?.driver_iranian === true ? true : false,
        },
        certificate_information: {
          ...data.certificate_information,
          license_type: data?.certificate_information?.license_type?.id
            ? {
                label: data?.certificate_information?.license_type?.fa_name,
                value: data?.certificate_information?.license_type?.id,
              }
            : undefined,
          license_issue_date: data?.certificate_information?.license_issue_date
            ? convertTimestampToShamsi(
                Number(data?.certificate_information?.license_issue_date),
              )
            : undefined,
          license_issue_location_country: data?.certificate_information
            ?.license_issue_location_country?.id
            ? {
                label:
                  data?.certificate_information?.license_issue_location_country
                    ?.name,
                value:
                  data?.certificate_information?.license_issue_location_country
                    ?.id,
              }
            : undefined,
          iran_license_issue_location_city: data?.certificate_information
            ?.iran_license_issue_location_city?.id
            ? {
                label:
                  data?.certificate_information
                    ?.iran_license_issue_location_city?.name,
                value:
                  data?.certificate_information
                    ?.iran_license_issue_location_city?.id,
              }
            : undefined,
        },
        mappedData: {
          personal_information: [
            {
              label: 'راننده مقصر :',
              value: data?.personal_information?.at_fault_driver?.fa_const,
            },
            {
              label: 'جنسیت راننده :',
              value: data?.personal_information?.gender?.fa_const,
            },
            {
              label: 'نام',
              value: data?.personal_information?.first_name,
            },
            {
              label: 'نام خانوادگی',
              value: data?.personal_information?.last_name,
            },
            {
              label: 'تاریخ تولد :',
              value:
                data?.personal_information?.birthdate &&
                convertTimestampToShamsi(
                  +data?.personal_information?.birthdate?.toString(),
                ),
            },
            {
              label: 'کد ملی :',
              value: data?.personal_information?.national_code,
            },
            {
              label: 'نام پدر',
              value: data?.personal_information?.father_name,
            },
            {
              label: 'شماره شناسنامه',
              value: data?.personal_information?.identity_number,
            },
            {
              label: 'محل صدور شناسنامه',
              value: data?.personal_information?.identity_issue_location,
            },
            {
              label: 'آیا راننده مالک وسیله‌نقلیه است',
              value: data?.personal_information?.is_owner_driver
                ? 'بله'
                : 'خیر',
            },
          ],
          contact: [
            {
              label: 'تلفن همراه',
              value: data.contact_information.phone_number,
            },
            {
              label: 'تلفن ',
              value: data.contact_information.phone,
            },
            {
              label: 'کد پستی',
              value: data.contact_information.postal_code,
            },
            {
              label: 'ادرس',
              value: data.contact_information.address,
            },
          ],
          certificate: [
            {
              label: 'نوع گواهینامه',
              value: data.certificate_information.license_type?.fa_name,
            },
            {
              label: 'شماره گواهینامه :',
              value: data.certificate_information.license_number,
            },
            {
              label: 'تاریخ صدور گواهینامه :',
              value:
                data?.certificate_information?.license_issue_date &&
                convertTimestampToShamsi(
                  +data?.certificate_information?.license_issue_date?.toString(),
                ),
            },
            {
              label: 'کشور محل صدور گواهینامه :',
              value:
                data.certificate_information.license_issue_location_country
                  ?.name,
            },
            {
              label: 'شهر محل صدور گواهینامه :',
              value:
                data.certificate_information.iran_license_issue_location_city
                  ?.name,
            },
          ],
        },
      };
    },
  });
};
